import type { Entry as UserEntry } from "@tandemdiabetes/sugarmate-api-react-client"
import type { MangoQuery } from "rxdb"

const defaultSelector = {}
const defaultSort = [{ started_at: "desc" as const }]

// adds "deleted_at" and "account_id" selector to entry query
export function createEntryQueryObject(
  accountId: number | undefined,
  {
    selector,
    sort,
    limit,
  }: MangoQuery<UserEntry>,
): MangoQuery<UserEntry> {
  return {
    selector: {
      ...(accountId ? { account_id: { $eq: accountId } } : {}),
      deleted_at: { $eq: null },
      ...(selector ?? defaultSelector),
    },
    sort: (sort ?? defaultSort),
    limit,
  }
}
